jQuery( function ( $ ) {

  $( '.team-member-go-back-link' ).on( 'click', function () {
    history.back();
  });

});